import { Inject, Injectable, InjectionToken } from '@angular/core';
import { noop } from 'lodash-es';
import { UnsubscribeCallback } from '../../custom-redux/reducer';

export const ESTENSA_NOTIFICATION_AUTHENTICATED_HUB_SERVICE = new InjectionToken(
    'estensa.module.connection.manager.hub.service'
);

export interface IEstensaNotificationAuthenticatedHubService {
    invoke(methodName: string, ...args: any[]): Promise<unknown>;
    off(eventName: string, callback: (...msg: any) => void): void;
    on(eventName: string, callback: (...msg: any) => void): UnsubscribeCallback;
}

export class NullAuthenticatedHubService implements IEstensaNotificationAuthenticatedHubService {
    invoke = () => Promise.resolve();
    off = noop;
    on = () => noop
}

@Injectable({
    providedIn: 'root',
})
export class EstensaNotificationAuthenticatedHubService {
    constructor(
        @Inject(ESTENSA_NOTIFICATION_AUTHENTICATED_HUB_SERVICE) private cmh: IEstensaNotificationAuthenticatedHubService
    ) {}

    invoke(methodName: string, ...args: any[]): Promise<unknown> {
        return new Promise((res, rej) =>
            this.cmh
                .invoke(methodName, ...args)
                .then(res)
                .catch(rej)
        );
    }

    off(eventName: string, callback: (...msg: any) => void): void {
        this.cmh.off(eventName, callback);
    }

    on(eventName: string, callback: (...msg: any) => void): UnsubscribeCallback {
        return this.cmh.on(eventName, callback);
    }
}
